<template>
  <app-layout title="Builder">
    <PageTitle :headerTitle="title"> </PageTitle>

    <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
      <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
        <form
          class="px-4 pt-4"
          method="post"
          action="{{ route('module.destroy',$module->name) }}"
        >
          <div class="mb-4"  v-show="!isStudio"  >
            <a
              class="
                bg-green-500
                text-white text-xs
                hover:bg-green-700 hover:no-underline
                rounded
                link-btn-style
              "
              href="#"
              id="ediBtn"
              >Edit</a
            >
            <a
              v-on:click="redeploy"
              v-show="isDeployed"
              class="
                bg-gray-500
                text-white text-xs
                hover:bg-gray-700 hover:no-underline
                rounded
                ml-2
                link-btn-style
              "
              href="#"
              id="reDeployBtn"
              >Redeploy</a
            >
            <a
              v-on:click="deploy"
              v-show="!isDeployed"
              class="
                bg-gray-500
                text-white text-xs
                hover:bg-gray-700 hover:no-underline
                rounded
                ml-2
                link-btn-style
              "
              href="#"
              id="deployBtn"
              >Deploy</a
            >
            <a
              v-on:click="publish"
             
              class="
                bg-gray-500
                text-white text-xs
                hover:bg-gray-700 hover:no-underline
                rounded
                ml-2
                link-btn-style
              "
              href="#"
              id="publishBtn"
              >Publish</a
            >
            
             <jet-button
              @click="exportModule"
             
              class="
                bg-gray-500
                text-white text-xs
                hover:bg-gray-700 hover:no-underline
                rounded
                ml-2
                cursor-pointer
                link-btn-style
              "
              >Export</jet-button
            >
            <a
              class="
                bg-gray-500
                text-white text-xs
                hover:bg-gray-700 hover:no-underline
                rounded
                ml-2
                link-btn-style
              "
             
              href="#"
              id="duplicateBtn"
              >Duplicate</a
            >

            <jet-button
              @click="deleteModule"
             
              class="
                bg-red-500
                text-white text-xs
                hover:bg-red-700 hover:no-underline
                rounded
                ml-2
                cursor-pointer
                link-btn-style
              "
              >Delete</jet-button
            >
            <jet-button
              @click="updateModule"             
              class="bg-green-500 text-white text-xs hover:bg-green-700 hover:no-underline rounded ml-2 cursor-pointer link-btn-style"
              >Update</jet-button>
              <jet-button
              @click="regenModule"             
              class="bg-green-500 text-white text-xs hover:bg-green-700 hover:no-underline rounded ml-2 cursor-pointer link-btn-style"
              >ReGenerate</jet-button>
            <a
              class="bg-gray-500 text-white text-xs hover:bg-gray-700 hover:no-underline rounded
                ml-2 
                link-btn-style float-right
              "
             
              href="#"
              id="gdeployBtn"
              @click="globalDeploy"
              >Globle Deploy</a>
            

            
            <!-- <jet-button
              @click="makeRelationship"
             
              class="
                bg-red-500
                text-white text-xs
                hover:bg-red-700 hover:no-underline
                rounded
                ml-2
                cursor-pointer
                link-btn-style
              "
              >Make Relationship</jet-button
            > -->



          </div>
        </form>

        <div class="px-4 pb-2">
          <BsShow
            :createDef="createDef"
            :routeDef="route"
            :modelData="moduleData"
          >
          </BsShow>
        </div>

        <div class="px-4 pb-4">
          <jet-nav-link
            :href="route('fields', { modulekey: moduleData.name,route_slug:slug })"
            class="
              bg-gray-500
              text-white text-xs
              hover:bg-gray-700 hover:no-underline
              rounded
              link-btn-style
            "
            >View fields</jet-nav-link>
          <jet-nav-link
            :href="
              route('relationships', { modulekey: moduleData.name,route_slug:slug })
            "
            class="
              bg-gray-500
              text-white text-xs
              hover:bg-gray-700 hover:no-underline
              rounded
              ml-2
              link-btn-style
            "
            >View Relationships</jet-nav-link
          >
          <jet-nav-link
            :href="route('layouts', { modulekey: moduleData.name,route_slug:slug })"
            class="
              bg-gray-500
              text-white text-xs
              hover:bg-gray-700 hover:no-underline
              rounded
              ml-2
              link-btn-style
            "
            >View Layouts</jet-nav-link
          >
        </div>
      </div>
      <DxToast
        v-model:visible="isVisible"
        v-model:message="message"
        v-model:type="type"
      />
    </div>
  </app-layout>
</template>

<style scoped>
.link-btn-style {
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 4px;
  padding-bottom: 4px;
}
.dx-toast-content {
  min-width: 300px;
  max-width: 400px;
}
</style>


<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import BsShow from "@/Base/BsShow.vue";
import PageTitle from "@/Layouts/PageTitle.vue";
import JetNavLink from "@/Jetstream/NavLink.vue";
import { DxToast } from "devextreme-vue/toast";
import { confirm, alert } from "devextreme/ui/dialog";

let collapsed = false;

export default {
  props: {
    isDeployed: Boolean,
    createDef: Array,
    moduleRoute:String,
    slug:String,
    isStudio:Boolean,
    modules: Array,
    moduleData: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    AppLayout,
    BsShow,
    PageTitle,
    JetNavLink,
    DxToast,
  },

  data() {
    return {
      txt: "kk",
      title: "Create Module",
      form: this.$inertia.form(),
      isVisible: false,
      is_general: this.moduleData.module_type == "general" ? true : false,
      message: "",
      type: "success",
    };
  },
  methods: {
    deploy() {
      // this.$inertia.get("/module/deploy/"+this.moduleData.name);

      this.form.get(route(this.moduleRoute+".deploy", [this.slug,this.moduleData.name]), {
        onSuccess: this.showToast("Successfully Deployed", "success"),
      });

    
    },
    exportModule(){
      
      this.form.get(route(this.moduleRoute+".export", [this.slug,this.moduleData.name]), {
        onSuccess: this.showToast("Successfully Export", "success"),
      });
        
    },
    redeploy() {
      // this.$inertia.get("/module/redeploy/"+this.moduleData.name);

      this.form.get(route(this.moduleRoute+".redeploy", [this.slug,this.moduleData.name]), {
        onSuccess: this.showToast("Successfully ReDeployed", "success"),
      });
      
    },
    publish() {
      // this.$inertia.get("/module/publish/"+this.moduleData.name);

      // [this.slug,e.data.id]
      this.form.get(route(this.moduleRoute+".publish", [this.slug,this.moduleData.name] ), {
        onSuccess: this.showToast("Successfully Published", "success"),
      });
    },
    globalDeploy()
    {
      this.form.get(route(this.moduleRoute+".gdeploy",[this.slug,this.moduleData.name]), {

        onSuccess: this.showToast("Successfully gDeployed", "success"),
      });
      
    },
    showToast(message, type) {
      this.isVisible = true;
      this.message = message;
      this.type = type;
    },

    deleteModule() {
      let result = confirm("<i>Are you sure?</i>", "Confirm changes");
      result.then((dialogResult) => {
        if (dialogResult) {
          this.form.delete(route(this.moduleRoute+".destroy", [this.slug,this.moduleData.name]), {
            errorBag: "delete",
            onSuccess: this.showToast("Successfully Deleted", "success"),
          });
        }
      });
    },
    regenModule()
    {
      this.form.get(route(this.moduleRoute+".mRegenerate",[this.slug,this.moduleData.name]), {

        onSuccess: this.showToast("Successfully Regenerated", "success"),
      });
    },
    updateModule()
    {
        this.form.get(route(this.moduleRoute+".mupdate",[this.slug,this.moduleData.name]), {

          onSuccess: this.showToast("Successfull Updated", "success"),
        });
    },
    makeRelationship(){

    //  this.$inertia.get(route(this.moduleRoute+".make_relationship", this.moduleData.name));
    
    }
  },
  mounted() {
    console.log("isStudio",this.isStudio);
  },
};
</script>
